import React, { useEffect, useState } from "react";
import { SearchsalesDetails } from "../../../Utility/Api";
import { toast } from 'react-toastify';
import { AddRemark } from "../../../Utility/Api";

const ReturnList = () => {
    const [Order, setOrder] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [ModalView, setModalView] = useState(false);
    const [un_id, setun_id] = useState(false);
    const [formData, setFormData] = useState({
        remark:"",
        sales_id:"",
        product_id:""
    });

    const handleModal = (item)=>{
        setun_id(item.unique_id)
        setFormData({...formData,["sales_id"]:item.id})
        setFormData({...formData,["product_id"]:item.product_id})
        setModalView(true)
    } 
    useEffect(() => {
        fetchOrders();
    }, [searchQuery]);


    const handleChange = (e)=>{
        const {name,value} = e.target
        setFormData({...formData,[name]:value})
    }
    const fetchOrders = async () => {
        try {
            const response = await SearchsalesDetails(searchQuery);
            if (response.data && response.data.data) {
                setOrder(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching Customer data:", error);
        }
    };

    const handleSubmit =async() => {
       
      const data = await AddRemark(formData,un_id)
          setModalView(false)
          toast.success("remark Updated successFully")
       }

    return (
        <div className="page-wrappers">
            <div className="page-content py-1">
                <div className="px-0 py-1 col-12">
                    <div
                        className="row justify-content-center row-gap-3 py-2"
                        style={{ background: "rgb(241, 243, 245)" }}
                    >
                        <div className="col-md-6 position-relative">
                            <div>
                                <div
                                    className="w-100"
                                    style={{ position: "relative", display: "inline-block" }}
                                >
                                    <input
                                        type="text"
                                        className="w-100"
                                        placeholder="Search"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{
                                            borderRadius: 1,
                                            border: "1px solid rgb(204, 204, 204)",
                                        }}
                                    />
                                    <img
                                        src="/assets/images/icons/search.png"
                                        alt="Search Icon"
                                        style={{
                                            position: "absolute",
                                            right: 10,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            height: 18,
                                            pointerEvents: "none",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="table-responsive text-center my-1 w-100 position-relative"
                        style={{ overflowX: "hidden", minHeight: "70vh" }}
                    >
                        <table className="table table-striped table-bordered">
                            <thead>
                            <tr>
                                    <th>#</th>
                                    <th>Unique No</th>
                                    <th>Product Name</th>
                                    <th>Customer</th>
                                    <th>sales Price</th>
                                    <th>Qty</th>
                                    <th>Total Price</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Order.map((order, index) => (
                                      <tr key={order.id}>
                                      <td>{index + 1}</td>
                                      <td>{order.unique_id || "N/A"}</td>
                                      <td>{order.product_name || "N/A"}</td>
                                      <td>{order.customer_name || "N/A"}</td>
                                      <td>{order.sales_price || "N/A"}</td>
                                      <td>{order.qty || "N/A"}</td>
                                      <td>{order.amount_per_price || "N/A"}</td>
                                      <td>
                                        <button
                                        className="btn btn-success"
                                        // onClick={()=>handleModal(order)}
                                        >View</button>
                                      </td>
                                  </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {ModalView && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  {"Add Remark"}
                </h5>
                <button
                onClick={()=>setModalView(false)}
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3 d-flex align-items-center">
                    <label className="col-4 text-normal">
                      Remark
                    </label>
                    <textarea
                      type="text"
                      name="remark"
                      className="form-control"
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="form-group mb-3 d-flex align-items-center">
                    <label className="col-4 text-normal">
                      Made of Payment
                    </label>
                <select  className="form-control">
                    <option value="" key="">Online</option>
                    <option value="" key="">offline</option>
                </select>
                  </div>

                  <div className="mt-5">
                    <button
                      type="submit"
                      className="btn btn-success float-end text-normal rounded-1"
                      style={{ fontFamily: "poppins" }}
                    >
                      Submit
                    </button>
                    &nbsp;
                    <button
                      type="button"
                      className="btn btn-secondary ml-2 float-end me-1 text-normal rounded-1"
                      onClick={()=>setModalView(false)}

                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
            </div>
        </div>
    );
};

export default ReturnList;
